import { ArrowRightGlobalNavigation } from 'src/components/icons/ArrowRightGlobalNavigation'
import { useMenu } from 'src/contexts/menu-context'
import Logo from '../../../Common/Logo'
import type { ParentAndLinkItemProps } from '../../../global-navigation'
import { hasNextLevel, isItemInPath } from '../../../utils'

export const WithLogo = ({ item, level, position }: ParentAndLinkItemProps) => {
  const { state } = useMenu()

  return (
    <div
      className={`py-3 flex flex-row gap-3 items-center justify-between mb-1 px-6 rounded-lg overflow-hidden transition-all navigation-link-panel ${
        isItemInPath(state, level, position) ? 'bg-yellow' : ''
      }`}
      data-category="small-animals"
      data-tab={`data-${item.label}`}
    >
      <div className="flex flex-row gap-2 items-center max-w-[calc(100%-36px)]">
        <Logo logo={item.logoImage ?? ''} label={item.label ?? ''} />
        <div className="max-w-full overflow-hidden">
          <span className="block text-sm font-semibold tracking-[-0.42px] text-[#232323]">
            {item.label}
          </span>
        </div>
      </div>
      {hasNextLevel(item) && (
        <span className="block w-6 h-6">
          <ArrowRightGlobalNavigation />
        </span>
      )}
    </div>
  )
}
